import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Button,
  Container,
} from '@mui/material';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';

const AuthenticationMsg = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.status);
  const message = queryParams.get('message');
  const isFailed = !!(message && message.length > 0);

  const handleClose = () => {
    window.close();
    navigate('/app');
  };

  useEffect(() => {
    function handleMessage(event) {
      if (event.origin !== window.location.origin) return;
      if (event.data.type === 'oauth-status') {
        if (event.data.status === 'success') {

        } else {

        }
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get('status');
    const message = params.get('message');
    if (window.opener) {
      window.opener.postMessage(
        { type: 'oauth-status', status, message },
        window.location.origin
      );
      setShowThanks(true);
    }
  }, [location]);

  return (
    <Container maxWidth="sm">
      <Card elevation={6} sx={{ mt: 8, textAlign: 'center' }}>
        <CardHeader
          title="Gmail Sync"
          sx={{
            backgroundColor: '#f5f5f5',
            borderBottom: '1px solid #ddd',
          }}
        />
        <CardContent sx={{ py: 6 }}>
          <Box mb={3} sx={{ display: 'flex', justifyContent: 'center' }}>
            {isFailed ? (
              <FaExclamationTriangle size={64} color="orange" />
            ) : (
              <FaCheckCircle size={64} color="green" />
            )}
          </Box>
          <Typography variant="h5" gutterBottom>
            {isFailed ? 'Gmail sync failed!' : 'Gmail sync Successful!'}
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            {isFailed ? decodeURIComponent(message) : 'Your Gmail has been successfully linked.'}
          </Typography>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </CardContent>
      </Card>
    </Container>
  )
}

export default AuthenticationMsg
